export default "__VITE_ASSET__FoWYlaUr__"